import { render, staticRenderFns } from "./ukTaxConfirmation.vue?vue&type=template&id=75309c46&scoped=true"
import script from "./ukTaxConfirmation.vue?vue&type=script&lang=js"
export * from "./ukTaxConfirmation.vue?vue&type=script&lang=js"
import style0 from "./ukTaxConfirmation.vue?vue&type=style&index=0&id=75309c46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75309c46",
  null
  
)

export default component.exports